import React from 'react';
import {Button, View, Text} from 'react-native';
import ManaBtn from "../../../components/ManaBtn";

class ErrorView extends React.Component {
    constructor(props) {
        super(props);
        this.clearError = props.clearError;
    }

    render() {
        //TODO: Draft
        const onRetry = this.onRetry.bind(this);
        return (
            <View style={{alignItems: 'center', justifyContent: 'center', flex: 1}}>
                <Text>
                    {'Internal Error'}
                </Text>
                <Text> </Text>
                <ManaBtn onPress={onRetry} title='Retry'/>
            </View>
        )
    }

    onRetry() {
        if (this.clearError != null) this.clearError();
    }
}

export default ErrorView;